import moment from "moment";
import React, { useEffect, useState, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { handleListResponse, seo, ValidateExtensionImge } from "utils/utils";
import { getAppointmentDetail } from "../../reduxStore/action/appointmentActions";
import {
  addBooking,
  removeAddBookingData,
} from "../../reduxStore/action/bookingActions";
import {
  getSiteVisitStatusData,
  updateSiteVisitStatus,
} from "../../reduxStore/action/siteVisitActions";
import { visitorDetail } from "reduxStore/action/visitorActions";
import { paymentTypes } from "reduxStore/action/masterActions";
import TimePicker from "react-time-picker";
import Breadcrumb from "component/common/breadcrumb";
import { handleDetailResponse, isEmpty } from "../../utils/utils";
import { getAgentProperty } from "reduxStore/action/propertyActions";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";
import { JW_LOGIN, JW_PASSWORD } from "utils/constants";
import { apiCall } from "utils/httpClient";
import apiEndPoints from "utils/apiEndPoints";
import { getPropertyDetail } from "reduxStore/action/propertyActions";
import {
  SupportRequest,
  ClosingManager,
  closing_head_id,
  ClosingTL,
  SourcingManager,
  SourcingTL,
  sourcing_head_id,
  SCM,
  SiteHead,
  BusinessHead,
  // AdminRoleId,
  // PostSale,
  // Receptionist,
  ClusterHead,
  admin_id,
  SourcingHead,
} from "../../utils/constants";

const AddBooking = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [propDetails, setPropDetails] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [formVaild, setFormVaild] = useState(null);
  const [appointmentData, setAppointmentData] = useState({});
  const [form, setForm] = useState({});
  const [apiResponse, setApiResponse] = useState([]);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [visitor, setVisitor] = useState({});
  const [loading, setLoading] = useState(false); // Local loading state
  const [floorInventory, setFloorInventory] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [flatTypes, setFlatTypes] = useState([]);
  const [masterType, setMasterType] = useState([]);
  const [floors, setFloors] = useState([]);
  const [flatName, setFlatName] = useState([]);
  const [mainInventory, setMainInventory] = useState([]);
  const [okBookingIsVisible, setOkBookingIsVisible] = useState(false);
  const [siteVisitMapping, setSiteVisitMapping] = useState(null);
  const getPropertyDetailSelector = useSelector((state) => state.propertyData);

  const masterDataSelector = useSelector((state) => state.paymentTypes);

  const { response: res } = useSelector((state) => state.login);

  const role_id = res?.data?.role_id;
  const Cmteam =
    ClosingTL === role_id ||
    ClosingManager === role_id ||
    closing_head_id === role_id;

  const SMteam =
    SourcingTL === role_id ||
    SourcingManager === role_id ||
    sourcing_head_id === role_id;

  const mixTeam =
    SCM === role_id ||
    SiteHead === role_id ||
    ClusterHead === role_id ||
    BusinessHead === role_id ||
    admin_id === role_id;

  useEffect(() => {
    if (getPropertyDetailSelector.response) {
      const { response } = getPropertyDetailSelector;
      if (response?.status === 200) {
        setPropDetails(handleDetailResponse(response?.data));
      } else {
        setPropDetails({});
      }
    }
  }, [getPropertyDetailSelector]);

  useEffect(() => {
    if (masterDataSelector.response) {
      const { response } = masterDataSelector;
      if (response?.status === 200) {
        setMasterType(handleListResponse(response.data));
      } else {
        setMasterType([]);
      }
    }
  }, [masterDataSelector]);

  // Function to fetch inventory list
  const handleGetInventoryList = async () => {
    setLoading(true); // Start loading
    const params = {
      jw_property_id: propDetails?.jw_project_id,
    };

    try {
      const res = await apiCall(
        "post",
        apiEndPoints.GETPROPERTYDETAILSJW,
        params
      );

      if (
        res?.data?.data?.result?.data &&
        Array.isArray(res?.data?.data?.result?.data) &&
        res?.data?.data?.result?.data.length > 0
      ) {
        const temp = res?.data?.data?.result?.data;

        const arr = temp;
        if (mainInventory.length === 0) {
          setMainInventory(Array.isArray(temp) ? temp : []); // Store main inventory - ensure it's an array
        }

        if (flatTypes.length === 0) {
          const tempFlatType = new Set(temp.map((el) => el["Flat Type"]));
          setFlatTypes(Array.from(tempFlatType)); // Extract unique flat types
        }

        const tempFloors = new Set(temp.map((el) => el["Floor"]));
        setFloors(Array.from(tempFloors)); // Extract unique floors

        const tempFlatName = new Set(temp.map((el) => el["Flat Name"]));
        setFlatName(Array.from(tempFlatName)); // Extract unique floors

        // Apply floor filter if selected
        if (form.floor) {
          const filteredData = temp.filter(
            (item) => item["Floor"] === form.floor
          );

          setInventory(filteredData); // Set filtered inventory
        } else {
          setInventory(arr); // Set unfiltered inventory
        }
      } else {
        setInventory([]); // If no data, clear inventory
        setMainInventory([]); // Ensure mainInventory is an array even if API returns no data
      }
    } catch (e) {
      console.error("Error fetching inventory:", e);
      setMainInventory([]); // Ensure mainInventory is an array even if API call fails
      setInventory([]);
    } finally {
      setLoading(false); // End loading
    }
  };

  useEffect(() => {}, [form]);

  useEffect(() => {
    if (propDetails?.jw_project_id) {
      handleGetInventoryList(); // Call the function when the component mounts or props change
    }
  }, [propDetails?.jw_project_id]);
  // const params = new URLSearchParams(window.location.search);

  const { appointment_id, lead_id } = params || {};

  useEffect(() => {
    if (lead_id) {
      setForm({ ...form, lead_id: lead_id });
    }
  }, [lead_id]);

  const getVisitorListSelector = useSelector(
    (state) => state.appointment?.response?.data
  );

  const propertySelector = useSelector((state) => state.propertyData);

  const appointmentDetailSelector = useSelector((state) => state.appointment);

  const visitorDetailSelector = useSelector((state) => state.visitor);

  const addBookingDetails = useSelector((state) => state.addBooking);

  useEffect(() => {
    if (addBookingDetails?.response?.status === 200) {
      // Send closing status update to LMS if mapping exists
      if (siteVisitMapping?.jv_site_visit_id) {
        const payload = {
          jvSiteVisitId: siteVisitMapping.jv_site_visit_id,
          closingStatus: "Booked",
          role: res?.data?.role_title || "auto",
        };

        dispatch(updateSiteVisitStatus(payload))
          .then((res) => {
            if (res) return true;
            return false;
          })
          .catch((err) => {
            console.error("❌ [Frontend] Error updating LMS:", err);
          });
      }
      setOkBookingIsVisible(true);
    }
  }, [addBookingDetails, dispatch]);

  const handleOkClick = () => {
    dispatch(removeAddBookingData());
    setOkBookingIsVisible(false);
    navigate("/booking_list"); // Redirect to /bookinglist
  };

  useEffect(() => {
    if (appointment_id) {
      dispatch(getAppointmentDetail({ appointment_id }));
    }
  }, [appointment_id, dispatch]);

  // Fetch site visit mapping for LMS integration
  useEffect(() => {
    if (appointment_id) {
      dispatch(getSiteVisitStatusData({ appointment_id }))
        .then((res) => {
          if (res?.data?.length > 0) {
            setSiteVisitMapping(res.data[0]);
          }
        })
        .catch((err) => {
          console.error("Error fetching site visit mapping:", err);
        });
    }
  }, [appointment_id, dispatch]);

  useEffect(() => {
    // dispatch(getMasterList({type:8}))
    dispatch(paymentTypes({ type: 10 }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(visitorDetail({ lead_id: appointmentData.lead_id }));
  }, [dispatch, appointmentData]);

  useLayoutEffect(() => {
    if (appointmentData?._id && appointmentData?.property_id) {
      dispatch(getPropertyDetail({ property_id: appointmentData.property_id }));
    }
  }, [dispatch, appointmentData?._id, appointmentData?.property_id]);

  useEffect(() => {
    if (visitorDetailSelector.response) {
      const { response } = visitorDetailSelector;
      if (response?.status === 200) {
        setVisitor(response?.data[0]);
      }
    }
  }, [visitorDetailSelector]);

  useEffect(() => {
    if (propertySelector.detail) {
      const { response } = propertySelector;
      if (response?.status === 200) {
        setApiResponse(handleListResponse(response.data));
      } else {
        setApiResponse([]);
      }
    }
  }, [propertySelector]);

  useEffect(() => {
    dispatch(getAgentProperty({ property_id: appointmentData.property_id }));
  }, [dispatch, appointmentData]);

  useEffect(() => {
    if (appointmentDetailSelector.response) {
      const { response } = appointmentDetailSelector;
      if (response?.status === 200) {
        setAppointmentData(handleDetailResponse(response?.data));
      } else {
        setAppointmentData({});
      }
    }
  }, [appointmentDetailSelector]);

  const leadSource =
    Array.isArray(appointmentData.lead_source) &&
    appointmentData.lead_source.length > 0
      ? appointmentData.lead_source[0]
      : null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const validAmount = /^[0-9]*\.?[0-9]*$/;

    if (name === "amount") {
      // Check if the value is valid or empty and update the state accordingly
      if (validAmount.test(value)) {
        setForm({
          ...form,
          [name]: value,
        });
      }
    } else {
      setForm({
        ...form,
        [name]: value,
      });
    }
    if (name === "floors") {
      setForm((prev) => ({ ...prev, floors: value, floor: value }));
      // Filter flats based on selected floor

      const filteredByFloor = inventory.filter(
        (flat) => flat.Floor === parseInt(value, 10)
      );

      setInventory(filteredByFloor);
    } else if (name === "configurations") {
      const safeMainInventory = Array.isArray(mainInventory)
        ? mainInventory
        : [];
      setInventory(safeMainInventory);
      setFloorInventory(safeMainInventory);
      setForm((prev) => ({
        ...prev,
        configurations: value,
        floors: "",
        floor: "",
        flat_name: "",
        saleable_area: "",
        carpet_area: "",
      }));

      // Filter flats based on selected configuration (flat type)
      const filteredByConfig = safeMainInventory.filter(
        (flat) => flat["Flat Type"] === value
      );

      setInventory(filteredByConfig);
      setFloorInventory(filteredByConfig);
    } else if (name === "flat_name") {
      const safeMainInventory = Array.isArray(mainInventory)
        ? mainInventory
        : [];
      const selectedFlat = safeMainInventory.find(
        (flat) => flat["Flat Name"] === value
      );
      // const filteredByConfig = mainInventory.filter((flat) => flat["Flat Name"] ===value);
      // setInventory(filteredByConfig);

      setForm((prev) => ({
        ...prev,
        flat_name: value,
        carpet_area: selectedFlat["Carpet Area"],
        floors: selectedFlat["Floor"],
        floor: selectedFlat["Floor"],
        configurations: selectedFlat["Flat Type"],
        saleable_area: selectedFlat["Saleable Area"],
      }));
    }
  };

  const handleChange = (e) => {
    if (e.target.files.length) {
      const validFile = ValidateExtensionImge(e.target.files[0]);
      let preview = "";
      let image = "";
      if (validFile === true) {
        preview = URL.createObjectURL(e.target.files[0]);
        image = e.target.files[0];
        // setFormVaild({
        //   ...formVaild,
        //   images: null,
        //   validMedia: null,
        // });
      } else {
        preview = "";
        image = "";
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: validFile,
        });
      }
      const nextFormState = {
        preview: preview,
        raw: image,
      };
      setImage(nextFormState);
    }
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const formData = new FormData();

      visitor?.customer_detail?._id &&
        formData.append("customer_id", visitor?.customer_detail?._id);
      // Append additional fields from the appointment data conditionally
      propDetails?.jw_project_id &&
        formData.append("jw_project_id", propDetails?.jw_project_id);
      appointmentData.crm_person_email &&
        formData.append("crm_person_email", appointmentData.crm_person_email);
      appointmentData.lead_source &&
        formData.append("lead_source", appointmentData.lead_source);
      appointmentData.lead_id &&
        formData.append("lead_id", appointmentData.lead_id);
      appointmentData.property_id &&
        formData.append("property_id", appointmentData.property_id);
      appointmentData._id &&
        formData.append("appointment_id", appointmentData._id);
      // Append form data conditionally using && to check both the field and its value
      if (image.raw) {
        formData.append("cheque_image", image.raw);
      }
      form.amount && formData.append("amount", form.amount);
      form.payment_type && formData.append("payment_type", form.payment_type);
      form.configurations && formData.append("flat_type", form.configurations);
      form.floors && formData.append("floor", form.floors);
      form.flat_name && formData.append("flat_no", form.flat_name);
      form.carpet_area && formData.append("carpet_area", form.carpet_area);
      form.saleable_area &&
        formData.append("saleable_area", form.saleable_area);
      form.comment && formData.append("description", form.comment);
      formData.append("booking_status", "2");

      dispatch(addBooking(formData));
    }
  };

  // Form validation
  const validateForm = () => {
    const errors = {};

    // Check if amount is a number and is not empty
    if (!form.amount || isNaN(form.amount)) {
      errors.amount = "Amount is required and must be a valid number.";
    }

    // Check if payment type is selected
    if (!form.payment_type) {
      errors.payment_type = "Please select a payment type.";
    }

    // Check if configuration is selected
    if (!form.configurations) {
      errors.configurations = "Please select a configuration.";
    }

    // Check if floors is selected
    if (!form.floors) {
      errors.floors = "Please select a floor.";
    }

    // Check if flat name is selected
    if (!form.flat_name) {
      errors.flat_name = "Please select a flat.";
    }

    // Check if carpet area is entered
    if (!form.carpet_area) {
      errors.carpet_area = "Carpet area is required.";
    }

    // Check if a comment is provided
    if (!form.comment) {
      errors.comment = "Comment is required.";
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  // Handle form submission

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.addBooking}
        url={"/addBooking"}
        //   parentListing={strings.appointmentList}
        //   titleactive={strings.addAppointment}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.addBooking}</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="lead_name">
                        {strings.name}
                        {/* <span className="required-field"></span> */}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="lead_name"
                        name="lead_name"
                        value={`${appointmentData.customer_first_name || ""} ${appointmentData.customer_last_name || ""}`.trim()}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="crm_person_email">
                        {strings.crmPersonEmail}
                        {/* <span className="required-field"></span> */}
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="crm_person_email"
                        name="crm_person_email"
                        value={appointmentData.crm_person_email || ""}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="lead_source">
                        {strings.leadSource}
                        {/* <span className="required-field"></span> */}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="lead_source"
                        name="lead_source"
                        value={appointmentData.lead_source}
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                {leadSource === "Channel Partner" && (
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="cp_name">
                          {strings.cpName}
                          {/* <span className="required-field"></span> */}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cp_name"
                          name="cp_name"
                          value={appointmentData.cp_name || ""}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="cp_employee_name">
                          {strings.cpEmployeeName}
                          {/* <span className="required-field"></span> */}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cp_employee_name"
                          name="cp_employee_name"
                          value={appointmentData.cp_emp_name || "NA"}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                )}

                {(leadSource === "Reference" ||
                  leadSource === "Referral Partner") && (
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="referrer_contact">
                          {strings.referrerNumber}
                          {/* <span className="required-field"></span> */}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="referrer_contact"
                          name="referrer_contact"
                          value={appointmentData.referrer_contact || ""}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="referrer_name">
                          {strings.referrerName}
                          {/* <span className="required-field"></span> */}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="referrer_name"
                          name="referrer_name"
                          value={appointmentData.referrer_name || "NA"}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                )}

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="amount">
                        {strings.amount}
                        {/* <span className="required-field"></span> */}
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="amount"
                        name="amount"
                        value={form.amount || ""}
                        onChange={handleInputChange} // assuming you have a function to handle the changes
                      />
                      {formErrors.amount && (
                        <span className="text-danger">{formErrors.amount}</span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="payment_type">
                        {strings.PaymentType}
                        {/* <span className="required-field"></span> */}
                      </label>
                      <select
                        className="form-control"
                        id="payment_type"
                        name="payment_type"
                        value={form.payment_type || ""}
                        onChange={handleInputChange}
                      >
                        {/* Default non-selectable placeholder */}
                        <option value="" disabled selected hidden>
                          Select Payment Type
                        </option>

                        {masterType.map((item, index) => (
                          <option key={item._id} value={item.title}>
                            {item.title}
                          </option>
                        ))}
                        {/* Add other options as necessary */}
                      </select>
                      {formErrors.payment_type && (
                        <span className="text-danger">
                          {formErrors.payment_type}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="configurations">
                        {strings.configuration}
                        {/* <span className="required-field"></span> */}
                      </label>
                      <select
                        className="form-control"
                        id="configurations"
                        name="configurations"
                        value={form.configurations || ""}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled selected hidden>
                          Select Configurations
                        </option>
                        {
                          // If form.flat_name exists, use mainInventory
                          Array.isArray(mainInventory) &&
                          mainInventory.length > 0
                            ? [
                                ...new Set(
                                  mainInventory.map((item) => item["Flat Type"])
                                ),
                              ].map((flatType, index) => (
                                <option key={index} value={flatType}>
                                  {flatType}
                                </option>
                              ))
                            : null
                        }
                      </select>
                      {formErrors.configurations && (
                        <span className="text-danger">
                          {formErrors.configurations}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="floors">
                        {strings.floors}
                        {/* <span className="required-field"></span> */}
                      </label>
                      <select
                        type="number"
                        className="form-control"
                        id="floors"
                        name="floors"
                        value={form.floors || ""}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled selected hidden>
                          Select Floor
                        </option>

                        {form.configurations === undefined
                          ? Array.isArray(mainInventory) &&
                            mainInventory.length > 0
                            ? [
                                ...new Set(
                                  mainInventory.map((item) => item["Floor"])
                                ),
                              ].map((floor, index) => (
                                <option key={index} value={floor}>
                                  {floor}
                                </option>
                              ))
                            : null
                          : Array.isArray(floorInventory) &&
                            floorInventory.length > 0
                          ? [
                              ...new Set(
                                floorInventory.map((item) => item["Floor"])
                              ),
                            ].map((floor, index) => (
                              <option key={index} value={floor}>
                                {floor}
                              </option>
                            ))
                          : null}
                      </select>
                      {formErrors.floors && (
                        <span className="text-danger">{formErrors.floors}</span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="flat_name">
                        {strings.flatName}
                        {/* <span className="required-field"></span> */}
                      </label>
                      <select
                        className="form-control"
                        id="flat_name"
                        name="flat_name"
                        value={form.flat_name || ""}
                        onChange={handleInputChange}
                      >
                        <option value="" disabled selected hidden>
                          Flat Name
                        </option>

                        {form?.floor !== undefined ||
                        form?.configurations !== undefined
                          ? // If form.floors or form.flatype exists, use inventory
                            Array.isArray(inventory) && inventory.length > 0
                            ? inventory.map((item, index) => (
                                <option key={index} value={item["Flat Name"]}>
                                  {item["Flat Name"]}
                                </option>
                              ))
                            : null
                          : // If form.floors or form.flatype does not exist, use mainInventory
                          Array.isArray(mainInventory) &&
                            mainInventory.length > 0
                          ? mainInventory.map((item, index) => (
                              <option key={index} value={item["Flat Name"]}>
                                {item["Flat Name"]}
                              </option>
                            ))
                          : null}
                        {/* Add more options as needed */}
                      </select>
                      {formErrors.flatName && (
                        <span className="text-danger">
                          {formErrors.flatName}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="carpet_area">
                        {strings.carpetArea}
                        {/* <span className="required-field"></span> */}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="carpet_area"
                        name="carpet_area"
                        value={form.carpet_area || ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="upload-button">
                        {strings.attachPhoto}
                        {/* <span className="required-field"></span> */}
                        <img
                          src={
                            image.preview
                              ? image.preview
                              : "/assets/images/user.png"
                          }
                          alt=""
                          width="150"
                          height="150"
                          style={{ borderRadius: "50%" }}
                          title={strings.attachPhoto}
                        />
                      </label>
                      {/* Hidden file input */}
                      <input
                        type="file"
                        id="upload-button"
                        style={{ display: "none" }}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="comment">{strings.comment}</label>
                      <textarea
                        className="form-control"
                        id="comment"
                        name="comment"
                        value={form.comment || ""}
                        onChange={handleInputChange}
                        rows="3"
                      ></textarea>
                    </div>
                  </div>

                  {/* Empty col-md-4 div to maintain row structure */}
                  <div className="col-md-4"></div>
                </div>

                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="card-footer">
                      <button
                        className="btn btn-color"
                        type="button"
                        onClick={() => handleSubmit()}
                      >
                        {strings.submit}
                      </button>
                    </div>
                  </div>
                  {!isEmpty(formVaild) && (
                    <div className="col-md-12 float-right">
                      <span
                        style={{
                          color: "red",
                          float: "right",
                          // padding: "5px 15px 25px 5px",
                        }}
                      >
                        {strings.fieldRequired}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Section */}
      {okBookingIsVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
            zIndex: 9999, // Ensure it appears on top
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "5px",
              textAlign: "center",
              maxWidth: "500px",
              width: "100%",
            }}
          >
            <h2>Success</h2>
            <p>Booking has been sent to CRM</p>
            <button
              style={{
                padding: "10px 20px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                cursor: "pointer",
              }}
              onClick={handleOkClick}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
export default AddBooking;
